import type { Logger } from "@expert/logging";
import type { KyInstance } from "ky";

import { HTTPError } from "ky";

import type { CustomerDetailsPayload } from "../../../../../types";
import type { GetCustomerDetailsParams } from "./types";

import { buildCustomerDetailsRequest, isValidPhoneNumberSearchType } from "./getCustomerDetails.helpers";

export const getCustomerDetails = async (
    client: KyInstance,
    logger: Logger,
    params: GetCustomerDetailsParams,
): Promise<CustomerDetailsPayload | null> => {
    const childLogger = logger.child({ module: "customerDetails" });
    const { dispatcher, customerDetailsCallback } = params;

    const jsonPayload = await buildCustomerDetailsRequest(params);
    if (!jsonPayload) {
        return null;
    }

    try {
        const apiPath = "v3/customer/details";
        const response = await client.post(apiPath, { json: jsonPayload, retry: 0 }).json<CustomerDetailsPayload>();

        if (response.primaryAccountHolder?.mdn && isValidPhoneNumberSearchType(params)) {
            response.primaryAccountHolder.mdn = params.mdn;
        }
        dispatcher?.dispatchBusinessEvent("CustomerDetailsStats", {
            includesPrimaryAccountHolder: !!response.primaryAccountHolder,
            includesAccountNumber: !!response.primaryAccountHolder?.accountNumber,
            includesCustomerAddress: !!response.primaryAccountHolder?.address,
            includesDeviceReplacementDetails: !!response.deviceActivation,
            includesPreviousSummary: !!response.previousSummary,
            previousDeviceCount: response.previousDevices?.length ?? 0,
        });

        customerDetailsCallback?.(response);

        return response;
    } catch (error: unknown) {
        if (error instanceof HTTPError) {
            childLogger.warn(
                { error, status: error.response.status },
                "getCustomerDetails API call failed with status",
            );
            return null;
        }
        childLogger.warn({ error }, "getCustomerDetails API call failed with exception");
        return null;
    }
};
